export const id = {
  title: 'Lanskap Hutan Utuh',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Fungsi',
      value:
        'Mengidentifikasi lanskap hutan tak terfragmentasi terakhir yang tersisa di dunia, cukup besar untuk mempertahankan semua keanekaragaman hayati asli dan tidak menunjukkan tanda-tanda perubahan dari manusia pada tahun 2020. Lapisan ini juga menunjukkan pengurangan luasan Lanskap Hutan Utuh dari tahun 2000 hingga 2020.',
    },
    {
      label: 'Resolusi',
      value: 'Perkiraan 1 : 1.000.000',
    },
    {
      label: 'Cakupan geografis',
      value: 'Global',
    },
    {
      label: 'Sumber',
      value:
        'Potapov, P., M. C. Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Zhuravleva, A. Komarova, S. Minnemeyer, and E. Esipova. 2017. "The last frontiers of wilderness: Tracking loss of intact forest landscapes from 2000 to 2013." Science Advances 3: e1600821.',
    },
    {
      label: 'Tanggal konten',
      value: 2020,
    },
    {
      label: 'Peringatan',
      value:
        'Peta IFL dunia diciptakan melalui interpretasi visual dari citra Landsat oleh para ahli. Peta ini mungkin tidak akurat karena keterbatasan resolusi spasial citra dan juga kurangnya informasi penunjang tentang praktik penggunaan lahan lokal di beberapa wilayah. Selain itu, metodologi ini berasumsi bahwa api di dekat jalan atau infrastruktur lainnya mungkin telah disebabkan oleh manusia, dan karena itu merupakan bentuk gangguan antropogenik. Asumsi ini dapat mengakibatkan penaksiran terlalu rendah dari sebaran IFL di bioma boreal.',
    },
    {
      label: 'Lisensi',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Ikhtisar',
    value:
      'Kumpulan data Lanskap Hutan Penuh (IFL) mengidentifikasi hamparan tak terputus ekosistem alam dalam zona batas hutan yang tidak menunjukkan tanda-tanda aktivitas manusia yang signifikan dan cukup besar bahwa semua keanekaragaman hayati asli, termasuk populasi yang layak dari berbagai macam spesies, dapat dipertahankan. Untuk memetakan daerah IFL, seperangkat kriteria dikembangkan dan dirancang untuk menjadi global yang berlaku dan mudah ditiru, yang terakhir untuk memungkinkan penilaian ulang dari waktu ke waktu serta verifikasi. Daerah IFL didefinisikan sebagai lanskap tak terfragmentasi, setidaknya 50.000 hektar, dan dengan lebar minimal 10 kilometer. Ini kemudian dipetakan dari citra satelit Landsat tahun 2000.',
  },
  citation: {
    label: 'Rujukan',
    value:
      'Greenpeace, University of Maryland, World Resources Institute and Transparent World. “Intact Forest Landscapes. 2000/2013/2016/2020” Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org',
  },
};
